import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import NewFoodIntakeForm from "./NewFoodIntake";
import FoodIntakeList from "./FoodIntakeList";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { LIST, CREATE } from "../../../../queries/food.query";
import LoadingSpinner from "../../../../partials/loading";
import { ReadData } from "../../../../providers/Patient.Provider";
import FoodDetail from "./FoodDetail.jsx";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";

const FoodIntake = () => {
    const [newForm, setNewForm] = useState(false);
    const [food, setFood] = useState(null);

    // local data
    const patient = ReadData();

    // query
    const { loading, data } = useQuery(LIST, {
        variables: { id: patient.lastAdmission || patient.id },
        onError: e => toast.error(CleanMessage(e.message))
    });

    const Cancel = () => {
        setNewForm(false);
        scrollTop();
        setFood(null);
    };
    // Mutation
    const [CreateFunc, { loading: cLoading }] = useMutation(CREATE, {
        update(caches, { data: { NewFoodIntake } }) {
            const { GetFoodIntakes } = caches.readQuery({
                query: LIST,
                variables: { id: patient.lastAdmission || patient.id }
            });
            // Add to list
            GetFoodIntakes.docs.unshift(NewFoodIntake.doc);
            caches.writeQuery({
                query: LIST,
                variables: { id: patient.lastAdmission || patient.id },
                data: { GetFoodIntakes }
            });
        },
        onError: e => toast.error(CleanMessage(e.message)),
        onCompleted: d => {
            if (d.NewFoodIntake) {
                toast.success(d.NewFoodIntake.message);
                setNewForm(false);
                scrollTop();
            }
        }
    });

    function scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    return (
        <>
            <Helmet>
                <title>Patient Food and Fluid Chart | {appName}</title>
            </Helmet>
            <div className="row justify-content-center">
                {newForm && !food && (
                    <div className="col md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button onClick={Cancel} title="Back" className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored">
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Record Food Intake
                                </header>
                            </div>
                            <div className="card-body m-b-20">
                                <LoadingSpinner loading={cLoading} />
                                <NewFoodIntakeForm
                                    onCancel={Cancel}
                                    onSubmit={async item => {
                                        await CreateFunc({
                                            variables: {
                                                model: {
                                                    ...item,
                                                    admission: patient.lastAdmission,
                                                    patient: patient.id
                                                }
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {!newForm && !food && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>Recorded Food Intake</header>
                                <div className="tools">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setNewForm(true);
                                            scrollTop();
                                            setFood(null);
                                        }}
                                        className="mdl-button mdl-button--icon btn-primary"
                                    >
                                        <i className="material-icons">add</i>
                                    </button>
                                </div>
                            </div>
                            <div className="card-body m-b-20" style={{ minHeight: "420px" }}>
                                <LoadingSpinner loading={loading} />
                                {!loading && (
                                    <FoodIntakeList
                                        className="fade-in"
                                        items={data && data.GetFoodIntakes.docs}
                                        onView={item => {
                                            setNewForm(false);
                                            scrollTop();
                                            setFood(item);
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {!newForm && food && (
                    <div className="col md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button onClick={Cancel} title="Back" className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored">
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Recorded Food Intake Detail
                                </header>
                            </div>
                            <div className="card-body m-b-20">
                                {/* Detail */}
                                <FoodDetail item={food} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default FoodIntake;
